import React from 'react';
import { Box } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import ProtectedRoute from '../../components/ProtectedRoute';
import UserSettings from './UserSettings';
import OrganizationSettings from './OrganizationSettings';
import AddressSettings from './AddressSettings';

const SettingsPage = () => {
  const { loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        {/* Loading handled by ProtectedRoute */}
      </Box>
    );
  }

  return (
    <ProtectedRoute>
      <Box>
        <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
          <AddressSettings />
          <UserSettings />
          <OrganizationSettings />
        </Box>
      </Box>
    </ProtectedRoute>
  );
};

export default SettingsPage;

